import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var SectionTitle =
/** @class */
function (_super) {
  __extends(SectionTitle, _super);

  function SectionTitle() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], SectionTitle.prototype, "arrow", void 0);

  SectionTitle = __decorate([Component({
    name: 'SectionTitle'
  })], SectionTitle);
  return SectionTitle;
}(Vue);

export default SectionTitle;